import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'getTicketStatusColorVariant',
  standalone: true,
})
export class GetTicketStatusColorVariantPipe implements PipeTransform {
  transform(statusId: number | null | undefined): 'neutral' | 'success' | 'warning' | 'error' | 'empty' {
    switch (statusId) {
      case 18:
      case 19:
      case 20:
      case 21:
      case 22:
      case 23:
        return 'warning';
      case 24:
      case 25:
      case 26:
        return 'success';
      default:
        return 'neutral';
    }
  }
}
